import React from 'react';
import {MyMatchesPlaceholder} from 'app/components/matchCalendar/MyMatchesPlaceholder';
import {Add, Star} from '@mui/icons-material';
import {useHistory} from 'react-router';
import {MY_MATCHES_SEARCH_ENTITIES} from 'app/components/follow/followHelper';

export const MyMatchesNoFollowsPlaceholder = () => {
  const history = useHistory();
  const action = {
    onClick: () => history.push('/search', {filters: MY_MATCHES_SEARCH_ENTITIES}),
    label: 'Favoriten hinzufügen',
    actionIcon: <Add color='icon-invert' />,
  };
  return (
    <MyMatchesPlaceholder
      icon={<Star color='action' fontSize='inherit' />}
      message='Erstelle automatisch deinen persönlichen Spielekalender, indem du Teams oder Wettbewerbe zu deinen Favoriten hinzufügst.'
      action={action}
    />
  );
};
